import { useTranslation } from 'react-i18next';

import Modal, { IconBlock, MessageBlock, ActionBlock, Title } from '@components/Modal';

const languageNamespace = 'printing-modals';
interface PrintModalProps {
  title: string;
  messages: string[];
  onContinue: () => void;
  onClose: () => void;
}

export const PrintWarningModal = ({ title, messages, onClose, onContinue }: PrintModalProps) => {
  const { t } = useTranslation([languageNamespace]);
  return (
    <Modal minWidth="42rem">
      <IconBlock icon="infoIcon" size={80} />
      <Title title={title} titleWeight="bolder" />
      <MessageBlock messages={messages} doubleLineBreakBetweenMsgs={true} />
      <ActionBlock
        actions={[
          {
            text: t('cancel'),
            onClick: onClose,
            appearance: 'secondary',
          },
          {
            text: t('continue'),
            onClick: onContinue,
            appearance: 'primary',
          },
        ]}
      />
    </Modal>
  );
};
